'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = toCss;

var _inlineStylePrefixer = require('inline-style-prefixer');

var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixer = new _inlineStylePrefixer2.default(typeof navigator !== 'undefined' && navigator || { userAgent: 'Chrome/20.0.1216.0' });

var AutoUnitless = ['animation', 'columnCount', 'columns', 'fontWeight', 'opacity', 'order', 'zIndex', 'zoom', 'flex', 'boxFlex', 'transform', 'perspective', 'boxPack', 'boxAlign', 'colspan', 'rowspan', 'lineHeight', 'WebkitLineClamp'];

var RE_CAMEL = /[A-Z]/g;
var RE_HYPHEN = /[-\s]+(.)?/g;

function hyphenate(str) {
  return str.replace(RE_CAMEL, function (w) {
    return '-' + w;
  }).toLowerCase();
}

function camelize(str) {
  return str.replace(RE_HYPHEN, function (m, w) {
    return w ? w.toUpperCase() : '';
  });
}

var objectHasOwn = Object.prototype.hasOwnProperty;

function hasOwn(object, propertyName) {
  return objectHasOwn.call(object, propertyName);
}

function isNumeric(val) {
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
  return type === 'number' || type === 'string' && val !== '' && val * 1 == val;
}

function toObject(styles) {
  var prepend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var key = void 0;
  var value = void 0;
  var property = void 0;
  for (key in styles) {
    if (!hasOwn(styles, key)) {
      continue;
    }

    value = styles[key];
    property = camelize(prepend ? prepend + key : key);

    if (value == null || property == null || property === '') {
      continue;
    }

    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      toObject(value, property + '-', result);
      continue;
    }

    if (isNumeric(value) && AutoUnitless.indexOf(property) < 0) {
      value = value + 'px';
    }

    result[property] = value;
  }

  return result;
}

function toCss(styles) {
  var prefixed = prefixer.prefix(toObject(styles));
  var collection = [];

  var key = void 0;
  for (key in prefixed) {
    if (hasOwn(prefixed, key)) {
      collection.push(hyphenate(key) + ':' + prefixed[key]);
    }
  }

  return collection.join(';');
}
module.exports = exports['default'];